import { render, staticRenderFns } from "./cus-table.vue?vue&type=template&id=4986c2b3&scoped=true&"
import script from "./cus-table.vue?vue&type=script&lang=js&"
export * from "./cus-table.vue?vue&type=script&lang=js&"
import style0 from "./cus-table.vue?vue&type=style&index=0&id=4986c2b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986c2b3",
  null
  
)

export default component.exports